module.exports = __webpack_public_path__ + "img/CertificateOfHonor05.888fe427.png";